var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gaokao-basic" },
    [
      _c(
        "el-card",
        { staticClass: "basic-card" },
        [
          _c("p", [
            _vm._v(" 本次考试，统计总人数 "),
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.totalNum))]),
            _vm._v(" 人。均分为 "),
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.avgScore))]),
            _vm._v(" 分，最高分为 "),
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.maxScore))]),
            _vm._v(" 分 "),
          ]),
          _vm._l(_vm.basicTable, function (item, index) {
            return _c("p", { key: "basicTable" + index }, [
              _vm._v(" " + _vm._s(item.lineName) + "模拟上线（ "),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(item.totalScore) + " "),
              ]),
              _vm._v(" 分）人数 "),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(item.stuNum) + " "),
              ]),
              _vm._v("人（ "),
              _c("span", { staticClass: "num" }, [
                _vm._v(" " + _vm._s(item.stuRate) + " "),
              ]),
              _vm._v("） "),
            ])
          }),
        ],
        2
      ),
      _c(
        "el-card",
        { staticClass: "basic-card" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.basicTable, border: "", size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "lineName",
                  label: "分数线名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalScore",
                  label: "总分有效分",
                  align: "center",
                  "render-header": _vm.renderHeader,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" ≥" + _vm._s(scope.row.totalScore) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "stuNum", label: "学生人数", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { prop: "stuRate", label: "占比", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.stuRate) + " ")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "basic-card" }, [
        _c("p", [
          _vm._v(
            " 单上线：单科分值≥有效分，即为单上线，这里统计的是上线人数。 "
          ),
        ]),
        _c("p", [_vm._v(" 双上线：单科和总分成绩均≥有效分，即为双上线。 ")]),
        _c("p", [_vm._v(" 贡献率：(双上线人数/总分上线人数) * 100% ")]),
        _c("p", [_vm._v(" 命中率：(双上线人数/单科上线人数) * 100% ")]),
      ]),
      _c(
        "p",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: _vm.lineKind === "First" ? "primary" : "",
              },
              on: {
                click: function ($event) {
                  _vm.lineKind = "First"
                },
              },
            },
            [_vm._v("特控线")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                size: "mini",
                type: _vm.lineKind === "Second" ? "primary" : "",
              },
              on: {
                click: function ($event) {
                  _vm.lineKind = "Second"
                },
              },
            },
            [_vm._v("本科线")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "basic-card" },
        [
          _c("ul-basic-school", {
            attrs: {
              "is-first": "",
              school: _vm.localSchool,
              "line-kind": _vm.lineKind,
            },
          }),
          _vm._l(_vm.totalList, function (school) {
            return _c("ul-basic-school", {
              key: "ul" + school.schoolId,
              attrs: { school: school, "line-kind": _vm.lineKind },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }